module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('mu-card', {
    attrs: {
      "id": "lifeRecommendations"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.lifeCategoryListsHeaderText'),
      "subTitle": _vm.$t('message.lifeCategoryListsSubHeaderText')
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('mu-list', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dummy-loader-' + index
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9 "
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "width": "16%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9 "
      },
      slot: "describe"
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('mu-list', _vm._l((_vm.data), function(item, index) {
    return (!_vm.isLoading && !item.post_private) ? _c('mu-list-item', {
      key: 'life-category-post-' + index
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(item.post_slug)
        }
      },
      slot: "title"
    }, [_vm._v(" ' →')\">")]), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "size": 50,
        "src": item.post_image || '',
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(item.post_slug)
        }
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-flat-button', {
      staticClass: "btn-outline",
      attrs: {
        "rippleColor": "#E74C3C",
        "disabled": !_vm.userId
      },
      nativeOn: {
        "click": function($event) {
          return _vm.favouritePost(item.post_id, index)
        }
      }
    }, [_c('span', {
      staticClass: "mu-icon material-icons",
      domProps: {
        "textContent": _vm._s(item.post_favourited ? 'favorite' : 'favorite_border')
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.post_favourites)
      }
    })])], 1)], 1) : _vm._e()
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b7f03a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LifeStyle/LifeCategoryList/LifeCategoryList.vue
// module id = 3726
// module chunks = 1